export const ZAJAVL_CONSENT_FILE_TYPE = 1;
export const ZAJAVL_REFUSAL_FILE_TYPE = 2;

export const TARGET_SOURCE_ID = 2;
export const DETAILED_TARGET_SOURCE_ID = 11;